exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".__parts-form-review__header[data-v-acc6fe7c],.__parts-form-review__name[data-v-acc6fe7c]{font-size:20px;font-weight:700;text-transform:uppercase;color:#333;text-align:center}.__parts-form-review__block[data-v-acc6fe7c]{margin-bottom:20px}.__parts-form-review__name[data-v-acc6fe7c]{margin-bottom:6px}.__parts-form-review__header[data-v-acc6fe7c]{margin-bottom:20px}.__parts-form-review__header.error[data-v-acc6fe7c]{color:red}.__parts-form-review__buttons[data-v-acc6fe7c],.__parts-form-review__rating[data-v-acc6fe7c]{text-align:center}.__parts-form-review__error[data-v-acc6fe7c]{color:red;font-weight:700;font-size:14px;text-align:center}.morespace[data-v-acc6fe7c]{padding:51px 0 27px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-acc6fe7c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/form/Review.vue
// module id = e9f2193fb285d01ee343
// module chunks = 0